<div class="container py-5 bg-light">
  <div class="container">
    <!-- Top Bar -->
    <div class="d-flex justify-content-end align-items-center mb-4">
      <!-- Left Links -->
      <!-- <div class="nav-links">
        <a
          routerLink="/privacy-policy"
          routerLinkActive="active-link"
          class="me-3 text-dark"
        >
          Privacy Policy
        </a>
        <a routerLink="/terms-conditions" routerLinkActive="active-link" class="text-dark">
          Terms & Conditions
        </a>
      </div> -->

      <!-- Language Switcher -->
      <div class="btn-group">
        <button
          class="btn btn-outline-success"
          [class.active]="currentLang === 'ta'"
          (click)="switchLang('ta')"
        >
          தமிழ்
        </button>

        <button
          class="btn btn-outline-success"
          [class.active]="currentLang === 'en'"
          (click)="switchLang('en')"
        >
          English
        </button>
      </div>
    </div>
  </div>

  <!-- ---------------- Tamil Version ---------------- -->
  <div *ngIf="currentLang === 'ta'">
    <div class="card shadow-sm">
      <div class="card-body">
        <h2 class="text-center mb-4">தனியுரிமைக் கொள்கை</h2>
        <p><strong>செயலில் வரும் தேதி:</strong> 01/12/2025</p>

        <p>
          <strong>Velmaral Seva Trust ("ஆயோஜகர்") CKTech Solution Pvt. Ltd.</strong> ("<strong>CKTech</strong>")
          வழங்கும் தளத்தின் மூலம் நிகழ்ச்சி பதிவுகளை நடத்துகிறது. இந்த
          தனியுரிமைக் கொள்கை, பங்கேற்பாளர் தகவல்கள் எவ்வாறு சேகரிக்கப்படுகின்றன,
          பயன்படுத்தப்படுகின்றன மற்றும் பாதுகாக்கப்படுகின்றன என்பதைக் கூறுகிறது.
        </p>

        <h5 class="mt-4 fw-bold">தரவை யார் சேகரிக்கிறார்</h5>
        <p>
          நிகழ்ச்சி பதிவு செய்யும் போது வழங்கப்படும் அனைத்து தனிப்பட்ட
          தகவல்களும் <strong>Velmaral Seva Trust</strong> சார்பாக மட்டுமே சேகரிக்கப்படுகின்றன.
        </p>
        <p>
          <strong>CKTech</strong> மென்பொருள் தளத்தை மட்டுமே வழங்குகிறது; பங்கேற்பாளர் தரவை
          சிஸ்டம் செயல்பாட்டிற்கு தேவையானவற்றைத் தவிர வேறு எந்த நோக்கத்திற்கும்
          பயன்படுத்தாது, செயலாக்காது அல்லது பகிராது.
        </p>

        <h5 class="mt-4 fw-bold">நாம் சேகரிக்கும் தகவல்கள்</h5>
        <ul>
          <li>
            பெயர், தொலைபேசி எண், மின்னஞ்சல் முகவரி, வயது மற்றும் நிகழ்ச்சி பதிவு
            செய்வதற்கு தேவையான பிற விவரங்கள்
          </li>
          <li>
            நிகழ்ச்சி வகை, தேதி மற்றும் விருப்பங்கள் போன்ற முன்பதிவு விவரங்கள்
          </li>
          <li>
            தளத்தின் பாதுகாப்பிற்காக அடிப்படை தொழில்நுட்ப தகவல்கள் (IP முகவரி,
            உலாவி வகை)
          </li>
        </ul>
        <p>
          <strong>CKTech</strong>, சிஸ்டம் செயல்பட தேவையானவற்றைத் தாண்டி பங்கேற்பாளர் தகவல்களை
          அணுகாது, பகுப்பாய்வு செய்யாது அல்லது பயன்படுத்தாது.
        </p>

        <h5 class="mt-4 fw-bold">தகவலை எவ்வாறு பயன்படுத்துகிறோம்</h5>
        <p><strong>Velmaral Seva Trust</strong> பங்கேற்பாளர் தகவலைப் பயன்படுத்தலாம்:</p>
        <ul>
          <li>நிகழ்ச்சி பதிவுகளை உறுதிப்படுத்த மற்றும் நிர்வகிக்க</li>
          <li>புதுப்பிப்புகள் அல்லது நிகழ்ச்சி தொடர்பான தகவல்களை வழங்க</li>
          <li>அமைப்பின் நிர்வாக தேவைகளுக்கான பதிவுகளை பராமரிக்க</li>
        </ul>

        <p>
          <strong>CKTech</strong> தரவை கீழ்க்கண்ட தொழில்நுட்ப செயல்பாடுகளுக்காக மட்டுமே
          பயன்படுத்துகிறது:
        </p>
        <ul>
          <li>பாதுகாப்பான படிவ சமர்ப்பிப்பு</li>
          <li>சிஸ்டம் செயல்திறன் மற்றும் பிழை மேலாண்மை</li>
        </ul>
        <p>
          <strong>CKTech</strong> நிகழ்ச்சி மேலாண்மை, தொடர்பு, கட்டண மேலாண்மை அல்லது
          முடிவெடுத்தல் ஆகியவற்றில் ஈடுபடாது.
        </p>

        <h5 class="mt-4 fw-bold">தரவுப் பகிர்வு</h5>
        <p>
          பங்கேற்பாளர் தகவல் ஆயோஜகர் மூலம் கீழ்க்கண்ட நிலைகளில் மட்டுமே
          பகிரப்படலாம்:
        </p>
        <ul>
          <li>நிகழ்ச்சியை நிர்வகிக்கும் நம்பிக்கை (Trust) உறுப்பினர்களுடன்</li>
          <li>சட்டத்தின் அடிப்படையில் தேவையானால் அதிகாரிகளுடன்</li>
        </ul>
        <p>
          <strong>CKTech</strong> பங்கேற்பாளர் தரவை எந்த வெளிப்புற தரப்பிற்கும் விற்காது, பகிராது
          அல்லது பரப்பாது.
        </p>

        <h5 class="mt-4 fw-bold">தரவு பாதுகாப்பு</h5>
        <p>
          தளத்தில் சேமிக்கப்பட்ட தரவை பாதுகாக்க <strong>CKTech</strong> தொழில்நுட்ப பாதுகாப்பு
          நடவடிக்கைகளை மேற்கொள்கிறது.
        </p>
        <p>
          ஆனால், சிஸ்டத்தைத் தாண்டி பங்கேற்பாளர் தரவு எவ்வாறு
          பயன்படுத்தப்படுகிறது அல்லது நிர்வகிக்கப்படுகிறது என்பதைப்
          பொறுப்பேற்குவது <strong>Velmaral Seva Trust</strong>.
        </p>

        <h5 class="mt-4 fw-bold">உங்கள் உரிமைகள்</h5>
        <p>பங்கேற்பாளர்கள் கீழ்க்கண்டவற்றை கோரலாம்:</p>
        <ul>
          <li>அவர்கள் சமர்ப்பித்த தரவின் நகலை</li>
          <li>தவறான தகவல்களை திருத்துதல்</li>
          <li>
            தரவு நீக்கம் (நம்பிக்கை கொள்கைகள் அல்லது சட்ட விதிகளின்
            அடிப்படையில்)
          </li>
        </ul>
        <p>
          இந்த கோரிக்கைகள் <strong>Velmaral Seva Trust</strong>-க்கு மட்டுமே செய்யப்பட வேண்டும்;
          <strong>CKTech</strong>-க்கு அல்ல.
        </p>

        <!-- <h5 class="mt-4">தொடர்பு தகவல்</h5>
        <p><strong>தனியுரிமை தொடர்பான கேள்விகள்:</strong></p>
        <p>
          <strong>Velmaral Seva Trust</strong><br />
          Email: [மின்னஞ்சல் சேர்க்கவும்]<br />
          Phone: [எண்களைச் சேர்க்கவும்]
        </p>

        <p><strong>தொழில்நுட்ப அல்லது தள பிரச்சினைகளுக்கு மட்டும்:</strong></p>
        <p>
          <strong>CKTech Solution Pvt. Ltd.</strong><br />
          Email: [மின்னஞ்சல் சேர்க்கவும்]
        </p> -->
      </div>
    </div>
  </div>

  <!-- ---------------- English Version ---------------- -->
  <div *ngIf="currentLang === 'en'">
    <div class="card shadow-sm">
      <div class="card-body">
        <h2 class="text-center mb-4">Privacy Policy</h2>
        <p><strong>Effective Date:</strong> 01/12/2025</p>

        <p>
          <strong>Velmaral Seva Trust ("Organizer") </strong>conducts event registrations
          through the platform provided by <strong>CKTech Solution Pvt. Ltd.</strong> ("<strong>CKTech</strong>").
          This Privacy Policy explains how participant information is collected,
          used, and protected.
        </p>

        <h5 class="mt-4 fw-bold">Who Collects the Data</h5>
        <p>
          All personal information submitted during event registration is
          collected solely on behalf of <strong>Velmaral Seva Trust</strong>.
        </p>
        <p>
          <strong>CKTech</strong> only provides the software platform and does not use, process,
          or share participant data for any purpose other than system
          functionality.
        </p>

        <h5 class="mt-4 fw-bold">Information We Collect</h5>
        <ul>
          <li>
            Name, phone number, email address, age, and other participant
            details required for event registration.
          </li>
          <li>Booking details such as event type, date, and preferences.</li>
          <li>
            Basic technical information (IP address, browser type) to ensure
            platform security.
          </li>
        </ul>
        <p>
          <strong>CKTech</strong> does not access, analyze, or utilize participant information
          beyond what is required for the system to function.
        </p>

        <h5 class="mt-4 fw-bold">How the Information Is Used</h5>
        <p><strong>Velmaral Seva Trust</strong> may use participant information to:</p>
        <ul>
          <li>Confirm and manage event registrations</li>
          <li>Communicate updates or event-related information</li>
          <li>Maintain participant records for organizational purposes</li>
        </ul>

        <p><strong>CKTech</strong> uses data only for technical operations, such as:</p>
        <ul>
          <li>Secure form submission</li>
          <li>System performance and error management</li>
        </ul>
        <p>
          <strong>CKTech</strong> does not engage in event management, communication, payment
          handling, or decision-making.
        </p>

        <h5 class="mt-4 fw-bold">Data Sharing</h5>
        <p>Participant information may be shared by the Organizer only:</p>
        <ul>
          <li>With internal trust members managing the event</li>
          <li>With authorities, if legally required</li>
        </ul>
        <p>
          <strong>CKTech</strong> does not sell, share, or distribute participant data to any
          third parties.
        </p>

        <h5 class="mt-4 fw-bold">Data Security</h5>
        <p>
          <strong>CKTech</strong> implements technical safeguards to protect the data stored on
          the platform.
        </p>
        <p>
          However, <strong>Velmaral Seva Trust</strong> is responsible for how participant data
          is used or managed beyond the software system.
        </p>

        <h5 class="mt-4 fw-bold">Your Rights</h5>
        <p>Participants may request:</p>
        <ul>
          <li>Access to their submitted data</li>
          <li>Correction of inaccurate information</li>
          <li>
            Deletion of data (subject to trust policies or legal requirements)
          </li>
        </ul>
        <p>
          Requests should be made directly to <strong>Velmaral Seva Trust</strong>, not <strong>CKTech</strong>.
        </p>

        <!-- <h5 class="mt-4">Contact Information</h5>
        <p><strong>For privacy-related concerns:</strong></p>
        <p>
          <strong>Velmaral Seva Trust</strong><br />
          Email: [Insert Email]<br />
          Phone: [Insert Number]
        </p>

        <p><strong>For technical or platform issues only:</strong></p>
        <p>
          <strong>CKTech Solution Pvt. Ltd.</strong><br />
          Email: [Insert Email]
        </p> -->
      </div>
    </div>
  </div>
</div>
<app-cktech-footer></app-cktech-footer>